import { generatePath, NavLink, useNavigate } from 'react-router-dom';
import {
  ButtonSecondary,
  formatPhone,
  IconArrowRight,
  IconChangeLoClock,
  IconClose,
  IconLock,
  IconSelected,
  InputText,
  PermissionEnum,
  ToggleInput,
} from '@ui/src';
import { ApplicationType } from '../../../hoc/new-application/types';
import { ClientdetailsTypes } from './types';

import ROUTES from '../../../routes';

import cn from './styles.module.css';

const ClientDetails = ({
  setUserDetailsActiveTab,
  activeLock,
  applicationType,
  applicationId,
  locks,
  getLocks,
  newApplicationInfo,
  activeStatus,
  updateClientInProgress,
  onUpdateClientStatus,
  activePermissions,
  recoveryInProgress,
  onResetPassword,
}: ClientdetailsTypes) => {
  const navigate = useNavigate();

  return (
    <div className={cn.clientDetails}>
      {activeLock && (
        <div className={cn.lockInfo}>
          <div className={cn.lockInfoLeft}>
            <div className={cn.lockInfoIcon}>
              <IconLock />
            </div>
            <div className={cn.lockInfoText}>Authorization is locked</div>
          </div>
          <div className={cn.lockInfoButtonWrapper}>
            <button
              type="button"
              className={cn.lockInfoButton}
              onClick={() => {
                setUserDetailsActiveTab('locks');

                let detailsLink = '';

                if (applicationType === ApplicationType.CORPORATE) {
                  detailsLink = ROUTES.CUSTOMERS_NEW_APPLICATION_CORPORATE_INFO;
                } else if (applicationType === ApplicationType.INDIVIDUAL) {
                  detailsLink =
                    ROUTES.CUSTOMERS_NEW_APPLICATION_INDIVIDUAL_INFO;
                } else if (
                  applicationType === ApplicationType.COMPANY_OFFICIAL ||
                  applicationType === ApplicationType.MAIN_REPRESENTATIVE
                ) {
                  detailsLink =
                    ROUTES.CUSTOMERS_NEW_APPLICATION_COMPANY_OFFICIAL;
                }

                navigate(
                  `${generatePath(detailsLink, {
                    applicationId: applicationId as string,
                  })}?locked=true`,
                );

                if (locks) {
                  getLocks(
                    `?take=20&userId=${newApplicationInfo?.user?.id}&locked=true`,
                  );
                }
              }}
            >
              <div className={cn.lockInfoButtonContent}>View locks</div>
              <div className={cn.lockInfoButtonContent}>
                <IconArrowRight width={12} height={12} />
              </div>
            </button>
          </div>
        </div>
      )}
      <div className={cn.totpInfo}>
        {newApplicationInfo?.user?.totpEnabled ? (
          <IconSelected />
        ) : (
          <IconClose width={15} height={15} className={cn.disabled} />
        )}
        TOTP-confirmation{' '}
        {newApplicationInfo?.user?.totpEnabled ? 'enabled' : 'not enabled'}
      </div>
      <div className={cn.formGroup}>
        <ToggleInput
          name="active"
          checked={Boolean(activeStatus === 'ACTIVE')}
          disabled={updateClientInProgress}
          onChange={(e) => {
            if (e.target.checked) {
              onUpdateClientStatus('ACTIVE');
            } else {
              onUpdateClientStatus('DISABLED');
            }
          }}
          title="Active"
        />
      </div>
      <div className={`${cn.formGroup} ${cn.formGroupFlex}`}>
        <InputText
          name="firstName"
          value={newApplicationInfo?.user?.profile?.firstName}
          placeholder=""
          title="First Name"
          labelClassName={cn.nameInput}
          disabled
        />
        <InputText
          name="lastName"
          value={newApplicationInfo?.user?.profile?.lastName}
          placeholder=""
          title="Last Name"
          labelClassName={cn.nameInput}
          disabled
        />
      </div>
      <div className={cn.formGroup}>
        <InputText
          name="id"
          value={newApplicationInfo?.user?.id}
          placeholder=""
          title="Identifier"
          disabled
        />
      </div>
      <div className={cn.formGroup}>
        <InputText
          name="phone"
          value={
            newApplicationInfo?.user?.phone
              ? formatPhone(newApplicationInfo?.user?.phone)
              : ''
          }
          placeholder=""
          title="Phone"
          disabled
        />
      </div>
      <div className={`${cn.formGroup} ${cn.moreMargin}`}>
        <InputText
          name="email"
          value={newApplicationInfo?.user?.email || '-'}
          placeholder=""
          title="Email"
          disabled
        />
      </div>
      {activePermissions?.includes(PermissionEnum.USERS_EDIT_ACTION) && (
        <>
          <ButtonSecondary
            className={cn.resetPassword}
            text={recoveryInProgress ? 'Loading...' : 'Reset user password'}
            onClick={onResetPassword}
            bold
          />
          <div className={cn.resetPasswordHint}>
            The current user password will be reset.
          </div>
        </>
      )}

      {activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) &&
        newApplicationInfo?.user?.id && (
          <NavLink
            to={`/administration/change-logs?entityType=USER&entityId=${newApplicationInfo?.user?.id}`}
            className={cn.changeLogLink}
            target="_blank"
          >
            <IconChangeLoClock />
            Change Log
          </NavLink>
        )}
    </div>
  );
};

export default ClientDetails;
